import React, { useEffect, useRef } from 'react';
import { Box } from '@mos-cat/ds';
import { pxToRem } from '@mos-cat/ds-theme';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import weekday from 'dayjs/plugin/weekday';
import 'whatwg-fetch';

import { DataProvider } from './context/DataProvider';
import SearchAddress from './components/SearchAddress';
import OutageInfo from './components/OutageInfo';
import RetryLaterModal from './components/RetryLaterModal';
import { sendStats, STATS_EVENTS } from './helpers/sendStats';
import metrika from './api/stats';

dayjs.locale('ru', {
  // День недели начинается в понедельника
  weekStart: 1,
  months: [
    'января',
    `февраля`,
    `марта`,
    `апреля`,
    `мая`,
    `июня`,
    `июля`,
    `августа`,
    `сентября`,
    `октября`,
    `ноября`,
    `декабря`,
  ],
});
dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(weekday);
metrika.initialize();

export default function App() {
  const comboboxRef = useRef<HTMLInputElement>(null);

  useEffect(function sendStatsOnMount() {
    sendStats(STATS_EVENTS.VIEW);
  }, []);

  return (
    <DataProvider>
      <Box data-cy="widget-container" maxWidth={pxToRem(768)}>
        <SearchAddress ref={comboboxRef} />
        <OutageInfo />
      </Box>
      <RetryLaterModal ref={comboboxRef} />
    </DataProvider>
  );
}
